import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const RULES = [
  "Le credenziali e i codici OTP sono personali e non cedibili: è vietato comunicarli a terzi, compresi colleghi e assistenza.",
  "L'accesso ai dati è consentito solo per le finalità operative del proprio incarico e limitatamente ai Trust collegati.",
  "È vietato esportare, copiare o inoltrare dati dei Trust fuori dalla piattaforma senza autorizzazione.",
  "Ogni sospetto incidente di sicurezza va segnalato immediatamente all'Amministratore (TM-ISMS-05).",
  "Al termine dell'utilizzo la sessione va chiusa; viene comunque chiusa automaticamente dopo 30 minuti di inattività.",
  "Tutti gli accessi e le operazioni sono registrati e possono essere oggetto di verifica.",
];

export function AupGate() {
  const { aupNeeded, setAupNeeded, refresh } = useAuth();
  const [ok, setOk] = useState(false);
  const accept = async () => {
    try {
      await api.post("/auth/accept-aup");
      setAupNeeded(false);
      await refresh();
      toast.success("Policy accettata");
      window.location.reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={aupNeeded}>
      <DialogContent className="bg-white max-w-xl [&>button]:hidden" data-testid="aup-dialog" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-heading">Policy di Utilizzo Accettabile</DialogTitle>
          <DialogDescription>Documento TM-ISMS-11 v1.1 — accettazione richiesta prima dell'utilizzo della piattaforma.</DialogDescription>
        </DialogHeader>
        <ol className="list-decimal pl-5 space-y-2 text-sm text-slate-700">{RULES.map((r) => <li key={r}>{r}</li>)}</ol>
        <label className="flex items-start gap-2 text-sm mt-2">
          <input type="checkbox" className="mt-1 accent-[#0A2540]" checked={ok} onChange={(e) => setOk(e.target.checked)} data-testid="aup-checkbox" />
          Dichiaro di aver letto e di accettare la Policy di Utilizzo Accettabile e gli obblighi di riservatezza.
        </label>
        <DialogFooter>
          <Button disabled={!ok} onClick={accept} data-testid="aup-accept-button" className="bg-[#0A2540] hover:bg-[#031B33] text-white">Accetto e proseguo</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
